import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!

  return (_openBlock(), _createBlock(_component_van_radio_group, {
    modelValue: _ctx.checkedVal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedVal) = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_van_cell, {
          key: item.value,
          title: item.label,
          class: _normalizeClass({ active: item.value === _ctx.checkedVal }),
          clickable: "",
          onClick: ($event: any) => (_ctx.checkedVal = item.value)
        }, null, 8, ["title", "class", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}